var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.47435 11.6667H3.58268C2.66602 11.6667 1.91602 12.4167 1.91602 13.3334V18.3334H7.47435V11.6667Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3585 8.33325H9.13346C8.2168 8.33325 7.4668 9.08325 7.4668 9.99992V18.3333H13.0251V9.99992C13.0251 9.08325 12.2835 8.33325 11.3585 8.33325Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.9171 14.1667H13.0254V18.3334H18.5837V15.8334C18.5837 14.9167 17.8337 14.1667 16.9171 14.1667Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7584 4.04174C13.0167 3.78341 13.1167 3.47508 13.0334 3.20841C12.9501 2.94174 12.6917 2.75008 12.3251 2.69175L11.5251 2.55841C11.4917 2.55008 11.4167 2.50006 11.4001 2.46673L10.9584 1.5834C10.6251 0.908398 9.86673 0.908398 9.5334 1.5834L9.09173 2.46673C9.07506 2.50006 9.00006 2.55008 8.96673 2.55841L8.16673 2.69175C7.80006 2.75008 7.55006 2.94174 7.4584 3.20841C7.37506 3.47508 7.47506 3.78341 7.7334 4.04174L8.35006 4.66674C8.37506 4.69174 8.4084 4.79174 8.40006 4.82508L8.22506 5.59173C8.09173 6.1584 8.3084 6.41673 8.45006 6.52506C8.59173 6.62506 8.90006 6.7584 9.4084 6.4584L10.1584 6.01674C10.1917 5.99174 10.3001 5.99174 10.3334 6.01674L11.0834 6.4584C11.3167 6.60007 11.5084 6.64174 11.6584 6.64174C11.8334 6.64174 11.9584 6.57506 12.0334 6.52506C12.1751 6.42506 12.3917 6.16673 12.2584 5.59173L12.0834 4.82508C12.0751 4.78341 12.1001 4.69174 12.1334 4.66674L12.7584 4.04174Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.988aa282abace363b0711220f42a5ba7.svg";
export { ForwardRef as ReactComponent };